angular.module("expenseQuotation.components", [])
    .component("expenseQuotation", {
        templateUrl: "ng/components/expenseQuotation/expenseQuotation.view.html",
        bindings: {
            model: "="
        },
        controllerAs: "expenseQuotationCtrl",
        controller: ExpenseQuotation
    });


function ExpenseQuotation() {
    var self = this;
    self.$onInit = function () {

    }
}